
import React from "react";
import { Button } from "@/components/ui/button";
import PricingPlanFeature from "./PricingPlanFeature";
import { LucideIcon } from "lucide-react";

type Feature = {
  text: string;
  description?: string;
};

type PricingPlanCardProps = {
  icon: LucideIcon;
  iconColor: string;
  title: string;
  description?: string;
  isBoldPrice?: boolean;
  features: (string | Feature)[];
  buttonText: string;
  buttonColor: string;
  isRecommended?: boolean;
  isDisabled?: boolean;
  onSelect: () => void;
};

const PricingPlanCard = ({ 
  icon: Icon, 
  iconColor, 
  title, 
  description, 
  isBoldPrice = false,
  features, 
  buttonText, 
  buttonColor, 
  isRecommended = false,
  isDisabled = false,
  onSelect
}: PricingPlanCardProps) => {
  return (
    <div className={`bg-white p-8 rounded-xl shadow-lg flex flex-col h-full ${isRecommended ? 'border-2 border-gebeya-pink relative' : ''}`}>
      {isRecommended && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-gebeya-pink text-white px-4 py-1 rounded-full text-sm">Recommended</span>
        </div>
      )}
      <div className="flex items-center gap-2 mb-4">
        <Icon className={`h-6 w-6 ${iconColor}`} />
        <h3 className="text-2xl font-bold">{title}</h3>
      </div>
      <div className="space-y-2">
        {description && (
          <p className={`text-lg ${isBoldPrice ? 'font-bold' : ''}`}>{description}</p>
        )}
      </div>
      <ul className="space-y-4 text-left mt-6 flex-grow">
        {features.map((feature, index) => {
          if (typeof feature === 'string') {
            return <PricingPlanFeature key={index} text={feature} />;
          } else {
            return <PricingPlanFeature key={index} text={feature.text} description={feature.description} />;
          }
        })}
      </ul>
      <Button 
        className={`w-full ${buttonColor} mt-6 text-white`}
        onClick={onSelect}
        disabled={isDisabled}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default PricingPlanCard;
